import { useEffect, useState } from "react";
import { showToast } from "../components/custom/custom-toast";
import { Branch } from "../models/response/branch";
import { ServiceFetcher } from "../services/service-fetcher";
import { ServiceQueryFetcher } from "../services/service-query-fetcher";
import CookieUtils from "../utils/cookie-utils";

export const useFetcherDataBranchWorking = () => {
  const token = CookieUtils.getCurrentUser().access_token ?? "";
  const [refresh, setRefresh] = useState<boolean>(false);

  const [dataBranchWorking, setDataBranchWorking] = useState<Branch[]>([]);
  const [dataQueryFetcher, setDataQueryFetcher] = useState<ServiceQueryFetcher>(new ServiceQueryFetcher());
  const { fetch: onGetBranchWorkingList, response: resBranchWorkingList } = ServiceFetcher.getBranchWorkingList();

  useEffect(() => {
    if (token === "") return;
    onGetBranchWorkingList({
      status: dataQueryFetcher.status,
      key_search: dataQueryFetcher.key_search,
    });
  }, [token, dataQueryFetcher, refresh]);

  useEffect(() => {
    if (!resBranchWorkingList) return;
    if (resBranchWorkingList.data) {
      setDataBranchWorking(resBranchWorkingList.data);
    } else {
      showToast({ message: resBranchWorkingList.message, type: "warning" });
    }
  }, [resBranchWorkingList]);

  const onRefresh = () => {
    setRefresh((prev) => !prev);
  };

  return { dataBranchWorking, dataQueryFetcher, setDataQueryFetcher, onRefresh };
};
